export default __webpack_public_path__ + "static/media/smart_vehicle.6155947f.jpeg";